<footer class="footer mt-auto py-3 bg-primary">
    <div class="container">
        <div class="d-flex flex-column justify-content-center pt-2">
          <div class="d-flex flex-row justify-content-around align-items-center pt-2 mb-3">
            <div>
              <p
                  class="text-white font-weight-light text-center flex-grow-1 mb-0 pb-2"
              >
                  Μια υπηρεσία του
              </p>
              <div class="mx-auto pb-4 logo_govgr logo_xsmall"></div>
            </div>
            <img class="greece2" src="/assets/images/Greece-2.0.png" alt="Greece 2.0">
          </div>

            <p class="text-white font-weight-light text-center flex-grow-1 mb-0 pb-2">
              <b>Αντιμετωπίζετε κάποιο πρόβλημα;</b>
            </p>
            <p class="text-white font-weight-light text-center flex-grow-1 mb-0 pb-2">
              Για την επικοινωνία σας με το Ελληνικό Κτηματολόγιο, παρακαλούμε επισκεφθείτε το <b>https://support.ktimatologio.gr</b> , <br> επιλέξτε την υπηρεσία που σας ενδιαφέρει και υποβάλλετε το αίτημα σας μέσω της <b>ΨΗΦΙΑΚΗΣ ΕΠΙΚΟΙΝΩΝΙΑΣ</b>.
            </p>
        </div>
    </div>
</footer>
